<template>
  <div class="delete-domain">
    <div class="step-1"
         v-if="step === 1">
      <div class="title-area">
        <i class="icon icon--dialog-trash"></i>
        <h4 v-html="$t('dashboard.deleteDomain.step1.title')"
            :class="{ long: domain.domain.length > 30 }"></h4>
      </div>
      <div class="domain-area">
        <span>{{ domain.domain }}</span>
      </div>
      <div class="content-area" v-html="$t('dashboard.deleteDomain.step1.description')"></div>
      <div class="warning-area"
            v-if="domain.matchType === 'simple'"
            v-html="$t('dashboard.deleteDomain.step1.warning')">
      </div>
      <div class="button-area">
        <ui-button :buttonType="'reset'"
                   @click="onCloseLayer">
          {{ $t('common.cancel') }}
        </ui-button>
        <ui-button :buttonType="'submit'"
                   :primary2="true"
                   @click="onStartDeletion">
          {{ $t('common.delete') }}
        </ui-button>
      </div>
    </div>
    <div class="step-2"
         v-else-if="step === 2">
      <div class="title-area">
        <i class="icon loading--dough"></i>
        <h4 v-html="$t('dashboard.deleteDomain.step2.title')"
            :class="{ long: domain.domain.length > 30 }"></h4>
      </div>
      <div class="domain-area">
        <span>{{ domain.domain }}</span>
      </div>
      <div class="progress-area">
        <span class="bar">
          <span :style="{ width: progress + '%'} "></span>
        </span>
        <span class="label"
              :class="{ full: progress > 97 } "
              :style="{ left: progress + '%'} ">{{ floorProgress }}%</span>
      </div>
      <div class="button-area">
        <ui-button @click="onCloseLayer">
          {{ $t('common.cancel') }}
        </ui-button>
      </div>
    </div>
    <div class="step-3"
         v-else-if="step === 3">
      <div class="title-area">
        <i class="icon icon--check-green-size50"></i>
        <h4 v-html="$t('dashboard.deleteDomain.step3.title')"
            :class="{ long: domain.domain.length > 30 }"></h4>
      </div>
      <div class="domain-area">
        <span>{{ domain.domain }}</span>
      </div>
      <div class="button-area">
        <ui-button @click="onCloseLayer">
          {{ $t('common.confirm') }}
        </ui-button>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import { deleteDomain } from '@/api/domain'

import UiButton from '@/components/ui/UiButton'

export default {
  name: 'DeleteDomain',
  components: {
    UiButton
  },
  props: [
    'domain'
  ],
  data () {
    return {
      step: 1,
      progress: 0,
      waitingTime: 10000,
      timer: null
    }
  },
  computed: {
    floorProgress () {
      return Math.floor(this.progress)
    }
  },
  methods: {
    onCloseLayer () {
      clearInterval(this.timer)
      this.timer = null
      this.$emit('onClose')
    },
    onStartDeletion () {
      this.timer = setInterval(() => {
        this.progress += 100 / (this.waitingTime / 100) * (2.5 - (2.5 / 100) * this.progress)
        if (this.progress >= 99.3) {
          this.doDelete()
        }
      }, 100)
      this.step = 2
    },
    doDelete () {
      clearInterval(this.timer)
      this.timer = null
      this.progress = 99.3

      deleteDomain({
        sid: this.domain.orgSid,
        matchType: this.domain.matchType
      }, true).then(() => {
        this.progress = 100
        this.step = 3
        this.$router.replace({ name: 'dashboard', query: {} })
        this.$emit('onDeleteSuccess')
      }).catch(() => {
        EventBus.$emit('onError')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-domain {
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  .title-area {
    text-align: center;
    padding: 50px 30px 0 30px;
    font-size: 20px;
    line-height: 1.25;
    color: #444444;
    word-break: keep-all;

    i {
      margin-bottom: 10px;
    }

    h4 {
      font-weight: normal;
      font-size: 20px;
      line-height: 1.25;
      color: #444444;

      & /deep/ em {
        color: #ec0047;
      }

      &.long /deep/ em {
        display: block;
        word-break: break-all;
      }
    }
  }

  .step-2 .title-area {
    padding-top: 25px;

    i {
      margin-bottom: 0;
    }
  }

  .domain-area {
    padding: 15px 25px 5px;
    line-height: 1.31;
    color: #fc004e;
    font-size: 16px;
    text-align: center;

    span {
      display: inline-block;
      max-width: calc(100% - 3ch);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: top;
    }

    &::before {
      content: '\'';
      display: inline-block;
      vertical-align: top;
    }

    &::after {
      content: '\'';
      display: inline-block;
      vertical-align: top;
    }
  }

  .content-area {
    color: #2f2f2f;
    line-height: 1.43;
    font-size: 14px;
    padding: 12px 50px 0 50px;
    text-align: center;

    span {
      color: #ec0047;
    }
  }
  .warning-area {
    padding: 12px 0;
    color: #E60724;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
  }

  .progress-area {
    margin: 17px 65px 20px 67px;
    position: relative;

    .bar {
      display: block;
      height: 10px;
      border-radius: 5px;
      background-color: rgba(215, 215, 215, 0.97);

      span {
        display: block;
        height: 100%;
        background-color: #fc004e;
        transition: width 0.1s linear,
                    border-top-right-radius 0.5s linear,
                    border-bottom-right-radius 0.5s linear;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;

        &.full {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
        }
      }
    }

    .label {
      position: absolute;
      top: 12px;
      left: 0;
      display: block;
      width: 30px;
      transform: translateX(-50%);
      text-align: center;
      transition: left 0.1s linear;
    }
  }

  .button-area {
    padding: 35px 0 30px 0;
    text-align: center;

    .ui-btn {
      margin: 0 2px 0 3px;
    }
  }
}
</style>
